import { getWebPlaysDbLazy, FUNNEL_VIEW_OPENED_SEPARATORS_STORE_NAME } from './dbService.js'

async function getStore(mode = 'readonly') {
  const db = await this.dbPromise
  return db
    .transaction(FUNNEL_VIEW_OPENED_SEPARATORS_STORE_NAME, mode)
    .objectStore(FUNNEL_VIEW_OPENED_SEPARATORS_STORE_NAME)
}

export class FunnelViewOpenedSeparatorsDbStore {
  constructor() {
    // Create a promise that resolves to the DB instance
    this.dbPromise = getWebPlaysDbLazy()
  }

  async get(playbookId) {
    const store = await getStore.call(this, 'readonly')
    const request = store.get(playbookId)

    return new Promise((resolve, reject) => {
      request.onsuccess = () => resolve(request.result?.openedSeparatorIds)
      request.onerror = () => reject(request.error)
    })
  }

  async save(playbookId, openedSeparatorIds) {
    const store = await getStore.call(this, 'readwrite')

    const record = { playbookId, openedSeparatorIds }

    const request = store.put(record)
    return new Promise((resolve, reject) => {
      request.onsuccess = () => resolve()
      request.onerror = () => reject(request.error)
    })
  }

  async remove(playbookId) {
    const store = await getStore.call(this, 'readwrite')
    const request = store.delete(playbookId)

    return new Promise((resolve, reject) => {
      request.onsuccess = () => resolve()
      request.onerror = () => reject(request.error)
    })
  }
}

export const instance = new FunnelViewOpenedSeparatorsDbStore()
